import React from 'react';

import CN from './DeleteCategoryButton.module.scss';

const DeleteCategoryButton = ({ onClick, ...extra }) => (
  <button data-bem="DeleteCategoryButton" className={CN.component} onClick={onClick} {...extra} />
);

export default DeleteCategoryButton;
